// isIE11
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('rv:11.0') !== -1;
})();
